import {
  AnimationEvent,
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import {
  Component,
  HostListener,
  Inject,
  Optional,
  Type,
  forwardRef
} from "@angular/core";

import { ModalRef } from "@lantern/app/core/utils/modals/modal-ref";
import {
  MODAL_COMPONENT_TYPE,
  MODAL_TEMPLATE_OPTIONS,
  ModalTemplateOptions
} from "@lantern/app/core/utils/modals/modal-tokens";

import { ModalComponent } from "./modal.component";

@Component({
  template: `
    <div id="modal-backdrop"></div>

    <div
      *ngIf="!modalResolved"
      @modalFlyInOut
      (@modalFlyInOut.done)="destroyContainer($event)"
    >
      <ng-template [ngIf]="modalComponentType != null">
        <ng-template [ngComponentOutlet]="modalComponentType"></ng-template>
      </ng-template>

      <ng-template [ngIf]="modalTemplateOptions != null">
        <ng-template
          [ngTemplateOutlet]="modalTemplateOptions.templateRef"
          [ngTemplateOutletContext]="modalTemplateOptions.context"
        >
        </ng-template>
      </ng-template>
    </div>
  `,
  animations: [
    trigger("modalFlyInOut", [
      state(
        "",
        style({
          opacity: 1
        })
      ),
      transition("void => *", [
        style({
          opacity: 0
        }),
        animate(100)
      ]),
      transition("* => void", [
        animate(
          100,
          style({
            opacity: 0
          })
        )
      ])
    ])
  ]
})
export class ModalContainerComponent<Response> {
  modalResolved: boolean = false;

  @HostListener("document:keydown.escape")
  keydownHandler(): void {
    this.modalRef.dismiss();
  }

  constructor(
    @Inject(forwardRef(() => ModalRef)) private modalRef: ModalRef<Response>,
    @Optional()
    @Inject(MODAL_COMPONENT_TYPE)
    public modalComponentType?: Type<ModalComponent<Response>>,
    @Optional()
    @Inject(MODAL_TEMPLATE_OPTIONS)
    public modalTemplateOptions?: ModalTemplateOptions<Response>
  ) {
    this.modalRef.response.subscribe(
      () => (this.modalResolved = true),
      () => (this.modalResolved = true)
    );
  }

  dismiss(err: any): void {
    this.modalRef.dismiss(err);
  }

  /**
   * @internal
   */
  destroyContainer(event: AnimationEvent): void {
    if (event.toState !== "void") {
      return;
    }
    this.modalRef.destroy();
  }
}
